// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard-module__font-s-10___Va4TY {
  font-size: 10px !important;
}

.Dashboard-module__font-s-12___zI7Mx {
  font-size: 12px !important;
}

.Dashboard-module__font-s-13___sdOFq {
  font-size: 13px !important;
}

.Dashboard-module__font-s-14___o6dlu {
  font-size: 14px !important;
}

.Dashboard-module__font-s-15___C824C {
  font-size: 15px !important;
}

.Dashboard-module__font-s-16___EHQyx {
  font-size: 16px !important;
}

.Dashboard-module__font-s-18___iyAao {
  font-size: 18px !important;
}

.Dashboard-module__font-s-20___AWbZs {
  font-size: 20px !important;
}

.Dashboard-module__font-s-22___ALoMi {
  font-size: 22px !important;
}

.Dashboard-module__font-s-28___PRqVo {
  font-size: 28px !important;
}

.Dashboard-module__font-w-400___PkAj2 {
  font-weight: 400 !important;
}

.Dashboard-module__font-w-500___G5GbJ {
  font-weight: 500 !important;
}

.Dashboard-module__font-w-600___HTe3f {
  font-weight: 600 !important;
}

.Dashboard-module__font-w-700___dCd6y {
  font-weight: 700 !important;
}

.Dashboard-module__p-5___FMvnr {
  padding: 5px !important;
}

.Dashboard-module__p-12___FMEyj {
  padding: 12px !important;
}

.Dashboard-module__p-16___giHTD {
  padding: 16px !important;
}

.Dashboard-module__p-30____2bJk {
  padding: 30px !important;
}

.Dashboard-module__p-b-0___lQ8i2 {
  padding-bottom: 0 !important;
}

.Dashboard-module__p-b-5___wTaUV {
  padding-bottom: 5px !important;
}

.Dashboard-module__p-b-10___h1ZDl {
  padding-bottom: 10px !important;
}

.Dashboard-module__p-b-12___gVTLf {
  padding-bottom: 12px !important;
}

.Dashboard-module__p-b-16___cCeXv {
  padding-bottom: 16px !important;
}

.Dashboard-module__p-b-18___iZY4t {
  padding-bottom: 18px !important;
}

.Dashboard-module__p-b-20___JaBCh {
  padding-bottom: 20px !important;
}

.Dashboard-module__p-b-25___cHdSv {
  padding-bottom: 25px !important;
}

.Dashboard-module__p-b-30___NIjVv {
  padding-bottom: 30px !important;
}

.Dashboard-module__p-b-50___zwuDt {
  padding-bottom: 50px !important;
}

.Dashboard-module__p-t-0___jjWbD {
  padding-top: 0 !important;
}

.Dashboard-module__p-t-12___NwoPy {
  padding-top: 12px !important;
}

.Dashboard-module__p-t-16___cBqmg {
  padding-top: 16px !important;
}

.Dashboard-module__p-t-18___sd_yb {
  padding-top: 18px !important;
}

.Dashboard-module__p-t-20___Ry7ZP {
  padding-top: 20px !important;
}

.Dashboard-module__p-t-30___p47A2 {
  padding-top: 30px !important;
}

.Dashboard-module__p-t-40___GJRRG {
  padding-top: 40px !important;
}

.Dashboard-module__p-t-50___iNBLO {
  padding-top: 50px !important;
}

.Dashboard-module__p-l-20___dIrkm {
  padding-left: 20px !important;
}

.Dashboard-module__p-l-30___8Sj5t {
  padding-left: 30px !important;
}

.Dashboard-module__p-l-40___lY1aM {
  padding-left: 40px !important;
}

.Dashboard-module__p-r-16___BB0kd {
  padding-right: 16px !important;
}

.Dashboard-module__p-r-20___jSK1R {
  padding-right: 20px !important;
}

.Dashboard-module__p-r-30___YDyOp {
  padding-right: 30px !important;
}

.Dashboard-module__p-r-50___vVZ6M {
  padding-right: 50px !important;
}

.Dashboard-module__p-r-60___LZNFi {
  padding-right: 60px !important;
}

.Dashboard-module__m-b-1___l80s_ {
  margin-bottom: 1px !important;
}

.Dashboard-module__m-b-2___HIw6Y {
  margin-bottom: 2px !important;
}

.Dashboard-module__m-b-6___ot1jA {
  margin-bottom: 6px !important;
}

.Dashboard-module__m-b-8___n2eGv {
  margin-bottom: 8px !important;
}

.Dashboard-module__m-b-10___IGwIX {
  margin-bottom: 10px !important;
}

.Dashboard-module__m-b-14___i92tH {
  margin-bottom: 14px !important;
}

.Dashboard-module__m-b-16___np4oF {
  margin-bottom: 16px !important;
}

.Dashboard-module__m-b-20___SYS6T {
  margin-bottom: 20px !important;
}

.Dashboard-module__m-b-22___MfdL2 {
  margin-bottom: 22px !important;
}

.Dashboard-module__m-b-24___PGrpV {
  margin-bottom: 24px !important;
}

.Dashboard-module__m-b-30___uqsws {
  margin-bottom: 30px !important;
}

.Dashboard-module__m-b-32___LVtA_ {
  margin-bottom: 32px !important;
}

.Dashboard-module__m-b-40___eo_XW {
  margin-bottom: 40px !important;
}

.Dashboard-module__m-t-2___uGlg3 {
  margin-top: 2px !important;
}

.Dashboard-module__m-t-3___HMd_i {
  margin-top: 3px !important;
}

.Dashboard-module__m-t-4___vBC0q {
  margin-top: 4px !important;
}

.Dashboard-module__m-t-5___kkMsp {
  margin-top: 5px !important;
}

.Dashboard-module__m-t-8___UukAY {
  margin-top: 8px !important;
}

.Dashboard-module__m-t-10___CtfLE {
  margin-top: 10px !important;
}

.Dashboard-module__m-t-15___SYtch {
  margin-top: 15px !important;
}

.Dashboard-module__m-t-16___jXmnA {
  margin-top: 16px !important;
}

.Dashboard-module__m-t-20___QeTTN {
  margin-top: 20px !important;
}

.Dashboard-module__m-t-22___LqRjG {
  margin-top: 22px !important;
}

.Dashboard-module__m-t-30___BWUV9 {
  margin-top: 30px !important;
}

.Dashboard-module__m-t-32___s1Mn1 {
  margin-top: 32px !important;
}

.Dashboard-module__m-l-auto___iwaaH {
  margin-left: auto !important;
}

.Dashboard-module__m-l-4___nGBRX {
  margin-left: 4px !important;
}

.Dashboard-module__m-l-5___bqxDY {
  margin-left: 5px !important;
}

.Dashboard-module__m-l-6___szAT9 {
  margin-left: 6px !important;
}

.Dashboard-module__m-l-8___XfVTW {
  margin-left: 8px !important;
}

.Dashboard-module__m-l-10___IdqAg {
  margin-left: 10px !important;
}

.Dashboard-module__m-l-16___fzzIm {
  margin-left: 16px !important;
}

.Dashboard-module__m-l-20___HLIDg {
  margin-left: 20px !important;
}

.Dashboard-module__m-l-24___kbTn1 {
  margin-left: 24px !important;
}

.Dashboard-module__m-l-30___JaFTA {
  margin-left: 30px !important;
}

.Dashboard-module__m-l-35___tOHee {
  margin-left: 35px !important;
}

.Dashboard-module__m-l-40___nFc5C {
  margin-left: 40px !important;
}

.Dashboard-module__m-r-8___zuO4E {
  margin-right: 8px !important;
}

.Dashboard-module__m-r-10___Y3D7A {
  margin-right: 10px !important;
}

.Dashboard-module__m-r-16___nrsPX {
  margin-right: 16px !important;
}

.Dashboard-module__m-r-20___NIiWk {
  margin-right: 20px !important;
}

.Dashboard-module__m-r-24___jsw1B {
  margin-right: 24px !important;
}

.Dashboard-module__m-r-30___uLqt1 {
  margin-right: 30px !important;
}

.Dashboard-module__m-r-40___QWoOH {
  margin-right: 40px !important;
}

.Dashboard-module__border-r-3___PIqST {
  border-radius: 3px !important;
}

.Dashboard-module__border-r-4___dC8xP {
  border-radius: 4px !important;
}

.Dashboard-module__border-r-6___eNyJZ {
  border-radius: 6px !important;
}

.Dashboard-module__border-r-10___oTqvm {
  border-radius: 10px !important;
}

.Dashboard-module__border-r-12___Iptjt {
  border-radius: 12px !important;
}

.Dashboard-module__border-r-16___eHfA8 {
  border-radius: 16px !important;
}

.Dashboard-module__border-r-50___ASgsJ {
  border-radius: 50% !important;
}

.Dashboard-module__primary-border___DU3Pu {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Dashboard-module__primary-border-b___L74fW {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Dashboard-module__primary-border-t___xrheA {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Dashboard-module__primary-border-l___yRRLK {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Dashboard-module__primary-border-r___UQT_4 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Dashboard-module__secondary-border___GJEgF {
  border: 1px solid #637768;
}

.Dashboard-module__secondary-border-b___rMHjc {
  border-bottom: 1px solid #637768;
}

.Dashboard-module__secondary-border-t___nRMCH {
  border-top: 1px solid #637768;
}

.Dashboard-module__secondary-border-l___iMtVa {
  border-left: 1px solid #637768;
}

.Dashboard-module__secondary-border-r___dARu7 {
  border-right: 1px solid #637768;
}

.Dashboard-module__gap-0___Neov9 {
  gap: 0 !important;
}

.Dashboard-module__gap-2___jDfui {
  gap: 2px !important;
}

.Dashboard-module__gap-4___EoTws {
  gap: 4px !important;
}

.Dashboard-module__gap-5___OLshL {
  gap: 5px !important;
}

.Dashboard-module__gap-6___nJb3T {
  gap: 6px !important;
}

.Dashboard-module__gap-8___Iv6Xu {
  gap: 8px !important;
}

.Dashboard-module__gap-10___DMMVy {
  gap: 10px !important;
}

.Dashboard-module__gap-12___CInov {
  gap: 12px !important;
}

.Dashboard-module__gap-14___Cvti4 {
  gap: 14px !important;
}

.Dashboard-module__gap-16___DjueF {
  gap: 16px !important;
}

.Dashboard-module__gap-18___u5mQT {
  gap: 18px !important;
}

.Dashboard-module__gap-20___QuALK {
  gap: 20px !important;
}

.Dashboard-module__gap-24___FEfn4 {
  gap: 24px !important;
}

.Dashboard-module__gap-26___cvzo2 {
  gap: 26px !important;
}

.Dashboard-module__gap-30____pQ5x {
  gap: 30px !important;
}

.Dashboard-module__gap-32___i0fEG {
  gap: 32px !important;
}

.Dashboard-module__gap-40___yC8EJ {
  gap: 40px !important;
}

.Dashboard-module__gap-50___rvUmo {
  gap: 50px !important;
}

.Dashboard-module__flex-1___bFNTr {
  flex: 1;
}

.Dashboard-module__flex-none___ZY3L4 {
  flex: none !important;
}

.Dashboard-module__flex-column___gxFat {
  display: flex;
  flex-direction: column !important;
}

.Dashboard-module__flex-row___aMRLl {
  display: flex;
  flex-direction: row !important;
}

.Dashboard-module__vertically-centered___ov7Jn {
  display: flex;
  align-items: center !important;
}

.Dashboard-module__horizontally-centered___ewBFy {
  display: flex;
  justify-content: center !important;
}

.Dashboard-module__horizontally-end___CtI_4 {
  display: flex;
  justify-content: end !important;
}

.Dashboard-module__vertically-start___CIJKr {
  display: flex;
  align-items: start !important;
}

.Dashboard-module__space-between___vf5FF {
  display: flex;
  justify-content: space-between !important;
}

.Dashboard-module__flex-wrap___ab8pT {
  flex-wrap: wrap !important;
}

.Dashboard-module__height-100___AUIgc {
  height: 100%;
}

.Dashboard-module__width-50___vviMm {
  width: 50% !important;
}

.Dashboard-module__width-100___fRqYj {
  width: 100%;
}

.Dashboard-module__cursor-pointer___HYj4o {
  cursor: pointer;
}

.Dashboard-module__cursor-not-allowed___CAIU9 {
  cursor: not-allowed !important;
}

.Dashboard-module__absolute-centered___JdQQT {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Dashboard-module__absolute___bhOnm {
  position: absolute;
}

.Dashboard-module__relative___N3ZAj {
  position: relative;
}

.Dashboard-module__fixed___wOj7J {
  position: fixed;
}

.Dashboard-module__visible___6ok_6 {
  opacity: 1;
}

.Dashboard-module__invisible___fVG5p {
  opacity: 0;
}

.Dashboard-module__col-90___R8S_g {
  width: 90% !important;
}

.Dashboard-module__col-auto___ogudP {
  width: auto !important;
}

.Dashboard-module__medical-tabs___Biykg {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Dashboard-module__medical-table-new___feiTc {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Dashboard-module__medical-table-new___feiTc:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Dashboard-module__medical-table-new___feiTc::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Dashboard-module__medical-table-new___feiTc::-webkit-scrollbar-track {
  display: none;
}
.Dashboard-module__medical-table-new___feiTc.Dashboard-module__no-pagination___zHyDG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Dashboard-module__medical-table-new___feiTc.Dashboard-module__no-pagination___zHyDG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Dashboard-module__medical-table-new___feiTc.Dashboard-module__no-pagination___zHyDG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Dashboard-module__medical-table-new___feiTc.Dashboard-module__no-pagination___zHyDG::-webkit-scrollbar-track {
  display: none;
}

.Dashboard-module__medical-table-empty___X2bfr {
  padding: 14px 40px !important;
}

.Dashboard-module__icon-btn___cxhZV {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Dashboard-module__search-icon___bjrp1 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Dashboard-module__disable-select___GBgQS {
  user-select: none;
}

.Dashboard-module__break-word___nJD99 {
  word-break: break-word;
}

.Dashboard-module__popup-clear-btn___uUF9P {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Dashboard-module__scroll-m-b-20___5qOPX {
  scroll-margin-bottom: 20px;
}

.Dashboard-module__hiddenTab___Duzzy {
  display: none;
}

.Dashboard-module__empty___DVsqI {
  height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 22px);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Dashboard/Dashboard.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;AA8pBF;;AA3pBA;EACE,iHAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.hiddenTab {\n  display: none;\n}\n\n.empty {\n  height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 22px\n  );\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Dashboard-module__font-s-10___Va4TY`,
	"fontS12": `Dashboard-module__font-s-12___zI7Mx`,
	"fontS13": `Dashboard-module__font-s-13___sdOFq`,
	"fontS14": `Dashboard-module__font-s-14___o6dlu`,
	"fontS15": `Dashboard-module__font-s-15___C824C`,
	"fontS16": `Dashboard-module__font-s-16___EHQyx`,
	"fontS18": `Dashboard-module__font-s-18___iyAao`,
	"fontS20": `Dashboard-module__font-s-20___AWbZs`,
	"fontS22": `Dashboard-module__font-s-22___ALoMi`,
	"fontS28": `Dashboard-module__font-s-28___PRqVo`,
	"fontW400": `Dashboard-module__font-w-400___PkAj2`,
	"fontW500": `Dashboard-module__font-w-500___G5GbJ`,
	"fontW600": `Dashboard-module__font-w-600___HTe3f`,
	"fontW700": `Dashboard-module__font-w-700___dCd6y`,
	"p5": `Dashboard-module__p-5___FMvnr`,
	"p12": `Dashboard-module__p-12___FMEyj`,
	"p16": `Dashboard-module__p-16___giHTD`,
	"p30": `Dashboard-module__p-30____2bJk`,
	"pB0": `Dashboard-module__p-b-0___lQ8i2`,
	"pB5": `Dashboard-module__p-b-5___wTaUV`,
	"pB10": `Dashboard-module__p-b-10___h1ZDl`,
	"pB12": `Dashboard-module__p-b-12___gVTLf`,
	"pB16": `Dashboard-module__p-b-16___cCeXv`,
	"pB18": `Dashboard-module__p-b-18___iZY4t`,
	"pB20": `Dashboard-module__p-b-20___JaBCh`,
	"pB25": `Dashboard-module__p-b-25___cHdSv`,
	"pB30": `Dashboard-module__p-b-30___NIjVv`,
	"pB50": `Dashboard-module__p-b-50___zwuDt`,
	"pT0": `Dashboard-module__p-t-0___jjWbD`,
	"pT12": `Dashboard-module__p-t-12___NwoPy`,
	"pT16": `Dashboard-module__p-t-16___cBqmg`,
	"pT18": `Dashboard-module__p-t-18___sd_yb`,
	"pT20": `Dashboard-module__p-t-20___Ry7ZP`,
	"pT30": `Dashboard-module__p-t-30___p47A2`,
	"pT40": `Dashboard-module__p-t-40___GJRRG`,
	"pT50": `Dashboard-module__p-t-50___iNBLO`,
	"pL20": `Dashboard-module__p-l-20___dIrkm`,
	"pL30": `Dashboard-module__p-l-30___8Sj5t`,
	"pL40": `Dashboard-module__p-l-40___lY1aM`,
	"pR16": `Dashboard-module__p-r-16___BB0kd`,
	"pR20": `Dashboard-module__p-r-20___jSK1R`,
	"pR30": `Dashboard-module__p-r-30___YDyOp`,
	"pR50": `Dashboard-module__p-r-50___vVZ6M`,
	"pR60": `Dashboard-module__p-r-60___LZNFi`,
	"mB1": `Dashboard-module__m-b-1___l80s_`,
	"mB2": `Dashboard-module__m-b-2___HIw6Y`,
	"mB6": `Dashboard-module__m-b-6___ot1jA`,
	"mB8": `Dashboard-module__m-b-8___n2eGv`,
	"mB10": `Dashboard-module__m-b-10___IGwIX`,
	"mB14": `Dashboard-module__m-b-14___i92tH`,
	"mB16": `Dashboard-module__m-b-16___np4oF`,
	"mB20": `Dashboard-module__m-b-20___SYS6T`,
	"mB22": `Dashboard-module__m-b-22___MfdL2`,
	"mB24": `Dashboard-module__m-b-24___PGrpV`,
	"mB30": `Dashboard-module__m-b-30___uqsws`,
	"mB32": `Dashboard-module__m-b-32___LVtA_`,
	"mB40": `Dashboard-module__m-b-40___eo_XW`,
	"mT2": `Dashboard-module__m-t-2___uGlg3`,
	"mT3": `Dashboard-module__m-t-3___HMd_i`,
	"mT4": `Dashboard-module__m-t-4___vBC0q`,
	"mT5": `Dashboard-module__m-t-5___kkMsp`,
	"mT8": `Dashboard-module__m-t-8___UukAY`,
	"mT10": `Dashboard-module__m-t-10___CtfLE`,
	"mT15": `Dashboard-module__m-t-15___SYtch`,
	"mT16": `Dashboard-module__m-t-16___jXmnA`,
	"mT20": `Dashboard-module__m-t-20___QeTTN`,
	"mT22": `Dashboard-module__m-t-22___LqRjG`,
	"mT30": `Dashboard-module__m-t-30___BWUV9`,
	"mT32": `Dashboard-module__m-t-32___s1Mn1`,
	"mLAuto": `Dashboard-module__m-l-auto___iwaaH`,
	"mL4": `Dashboard-module__m-l-4___nGBRX`,
	"mL5": `Dashboard-module__m-l-5___bqxDY`,
	"mL6": `Dashboard-module__m-l-6___szAT9`,
	"mL8": `Dashboard-module__m-l-8___XfVTW`,
	"mL10": `Dashboard-module__m-l-10___IdqAg`,
	"mL16": `Dashboard-module__m-l-16___fzzIm`,
	"mL20": `Dashboard-module__m-l-20___HLIDg`,
	"mL24": `Dashboard-module__m-l-24___kbTn1`,
	"mL30": `Dashboard-module__m-l-30___JaFTA`,
	"mL35": `Dashboard-module__m-l-35___tOHee`,
	"mL40": `Dashboard-module__m-l-40___nFc5C`,
	"mR8": `Dashboard-module__m-r-8___zuO4E`,
	"mR10": `Dashboard-module__m-r-10___Y3D7A`,
	"mR16": `Dashboard-module__m-r-16___nrsPX`,
	"mR20": `Dashboard-module__m-r-20___NIiWk`,
	"mR24": `Dashboard-module__m-r-24___jsw1B`,
	"mR30": `Dashboard-module__m-r-30___uLqt1`,
	"mR40": `Dashboard-module__m-r-40___QWoOH`,
	"borderR3": `Dashboard-module__border-r-3___PIqST`,
	"borderR4": `Dashboard-module__border-r-4___dC8xP`,
	"borderR6": `Dashboard-module__border-r-6___eNyJZ`,
	"borderR10": `Dashboard-module__border-r-10___oTqvm`,
	"borderR12": `Dashboard-module__border-r-12___Iptjt`,
	"borderR16": `Dashboard-module__border-r-16___eHfA8`,
	"borderR50": `Dashboard-module__border-r-50___ASgsJ`,
	"primaryBorder": `Dashboard-module__primary-border___DU3Pu`,
	"primaryBorderB": `Dashboard-module__primary-border-b___L74fW`,
	"primaryBorderT": `Dashboard-module__primary-border-t___xrheA`,
	"primaryBorderL": `Dashboard-module__primary-border-l___yRRLK`,
	"primaryBorderR": `Dashboard-module__primary-border-r___UQT_4`,
	"secondaryBorder": `Dashboard-module__secondary-border___GJEgF`,
	"secondaryBorderB": `Dashboard-module__secondary-border-b___rMHjc`,
	"secondaryBorderT": `Dashboard-module__secondary-border-t___nRMCH`,
	"secondaryBorderL": `Dashboard-module__secondary-border-l___iMtVa`,
	"secondaryBorderR": `Dashboard-module__secondary-border-r___dARu7`,
	"gap0": `Dashboard-module__gap-0___Neov9`,
	"gap2": `Dashboard-module__gap-2___jDfui`,
	"gap4": `Dashboard-module__gap-4___EoTws`,
	"gap5": `Dashboard-module__gap-5___OLshL`,
	"gap6": `Dashboard-module__gap-6___nJb3T`,
	"gap8": `Dashboard-module__gap-8___Iv6Xu`,
	"gap10": `Dashboard-module__gap-10___DMMVy`,
	"gap12": `Dashboard-module__gap-12___CInov`,
	"gap14": `Dashboard-module__gap-14___Cvti4`,
	"gap16": `Dashboard-module__gap-16___DjueF`,
	"gap18": `Dashboard-module__gap-18___u5mQT`,
	"gap20": `Dashboard-module__gap-20___QuALK`,
	"gap24": `Dashboard-module__gap-24___FEfn4`,
	"gap26": `Dashboard-module__gap-26___cvzo2`,
	"gap30": `Dashboard-module__gap-30____pQ5x`,
	"gap32": `Dashboard-module__gap-32___i0fEG`,
	"gap40": `Dashboard-module__gap-40___yC8EJ`,
	"gap50": `Dashboard-module__gap-50___rvUmo`,
	"flex1": `Dashboard-module__flex-1___bFNTr`,
	"flexNone": `Dashboard-module__flex-none___ZY3L4`,
	"flexColumn": `Dashboard-module__flex-column___gxFat`,
	"flexRow": `Dashboard-module__flex-row___aMRLl`,
	"verticallyCentered": `Dashboard-module__vertically-centered___ov7Jn`,
	"horizontallyCentered": `Dashboard-module__horizontally-centered___ewBFy`,
	"horizontallyEnd": `Dashboard-module__horizontally-end___CtI_4`,
	"verticallyStart": `Dashboard-module__vertically-start___CIJKr`,
	"spaceBetween": `Dashboard-module__space-between___vf5FF`,
	"flexWrap": `Dashboard-module__flex-wrap___ab8pT`,
	"height100": `Dashboard-module__height-100___AUIgc`,
	"width50": `Dashboard-module__width-50___vviMm`,
	"width100": `Dashboard-module__width-100___fRqYj`,
	"cursorPointer": `Dashboard-module__cursor-pointer___HYj4o`,
	"cursorNotAllowed": `Dashboard-module__cursor-not-allowed___CAIU9`,
	"absoluteCentered": `Dashboard-module__absolute-centered___JdQQT`,
	"absolute": `Dashboard-module__absolute___bhOnm`,
	"relative": `Dashboard-module__relative___N3ZAj`,
	"fixed": `Dashboard-module__fixed___wOj7J`,
	"visible": `Dashboard-module__visible___6ok_6`,
	"invisible": `Dashboard-module__invisible___fVG5p`,
	"col90": `Dashboard-module__col-90___R8S_g`,
	"colAuto": `Dashboard-module__col-auto___ogudP`,
	"medicalTabs": `Dashboard-module__medical-tabs___Biykg`,
	"medicalTableNew": `Dashboard-module__medical-table-new___feiTc`,
	"noPagination": `Dashboard-module__no-pagination___zHyDG`,
	"medicalTableEmpty": `Dashboard-module__medical-table-empty___X2bfr`,
	"iconBtn": `Dashboard-module__icon-btn___cxhZV`,
	"searchIcon": `Dashboard-module__search-icon___bjrp1`,
	"disableSelect": `Dashboard-module__disable-select___GBgQS`,
	"breakWord": `Dashboard-module__break-word___nJD99`,
	"popupClearBtn": `Dashboard-module__popup-clear-btn___uUF9P`,
	"scrollMB20": `Dashboard-module__scroll-m-b-20___5qOPX`,
	"hiddenTab": `Dashboard-module__hiddenTab___Duzzy`,
	"empty": `Dashboard-module__empty___DVsqI`
};
module.exports = ___CSS_LOADER_EXPORT___;
